import { DrEntity } from './dr-entity';
import { AliasReportTitle } from '../models/report';

// represents the object returned from the rest api
export class ReportGenerationProfileEntry {
    attributes = new Array<string>();
    handle: string;
    reportCategory: string;
    reports = new Array<string>();
    constructor(reportCategory: string) {
        if (reportCategory) {
            this.reportCategory = reportCategory;
        }
    }
}

export class ReportSettingViewData {
    reportId: string;
    userFriendlyName: string;
    imports: boolean;  // aka corpus set
    dataSets: boolean;  // aka corpus
    projectData: boolean;  // aka working set

    constructor(value?: Partial<ReportSettingViewData>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class ReportGenerationProfile extends DrEntity {
    defaultProfile: boolean;
    handle: string;
    projectId: string;                 // this can be an id to project data or an organization
    name: string;
    version: string;
    allReports = new Array<string>();    // this comes from the getReportSettings() call.
    viewData = new Map<string, any>(); // any=ReviewSettingViewData

    constructor(value?: Partial<any>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }

        // if (value.reportGenerationProfileDto.handle) {
        //    this.handle = value.reportGenerationProfileDto.handle;
        // }

        if (value.reportGenerationProfileDto.defaultProfile) {
            this.defaultProfile = value.reportGenerationProfileDto.defaultProfile;
        }

        if (value.reportGenerationProfileDto.projectId) {
            this.projectId = value.reportGenerationProfileDto.projectId;
        }

        if (value.reportGenerationProfileDto.name) {
            this.name = value.reportGenerationProfileDto.name;
        }

        if (value.reportGenerationProfileDto.version) {
            this.version = value.reportGenerationProfileDto.version;
        }

        if (value.reportGenerationProfileDto.allReports) {
            this.allReports = value.reportGenerationProfileDto.allReports;
        }

        this.initializeViewData();
    }

    initializeViewData(): void {
        let currentViewData = new ReportSettingViewData();
        // BILLING_REPORT
        currentViewData.reportId = 'BILLING_REPORT';
        currentViewData.userFriendlyName = AliasReportTitle.BILLING_REPORT;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // GROUP_VIEW_MEMBERSHIP
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'GROUP_VIEW_MEMBERSHIP';
        currentViewData.userFriendlyName = AliasReportTitle.GROUP_VIEW_MEMBERSHIP;
        currentViewData.imports = undefined;
        currentViewData.dataSets = undefined;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // CUSTODIAN_DIRECTORY_REPORT (s)
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'CUSTODIAN_DIRECTORY_REPORT';
        currentViewData.userFriendlyName = AliasReportTitle.CUSTODIAN_DIRECTORY_REPORT;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // CUSTOM_WARNINGS_ERRORS
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'CUSTOM_WARNINGS_ERRORS';
        currentViewData.userFriendlyName = AliasReportTitle.CUSTOM_WARNINGS_ERRORS;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // DATE_PRIMARY
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'DATE_PRIMARY';
        currentViewData.userFriendlyName = AliasReportTitle.DATE_PRIMARY;
        currentViewData.imports = undefined;
        currentViewData.dataSets = undefined;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // DOCUMENT_CLASS
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'DOCUMENT_CLASS';
        currentViewData.userFriendlyName = AliasReportTitle.DOCUMENT_CLASS;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // TECHNICAL_REDUCTION
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'TECHNICAL_REDUCTION';
        currentViewData.userFriendlyName = AliasReportTitle.TECHNICAL_REDUCTION;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // FILETYPE
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'FILETYPE';
        currentViewData.userFriendlyName = AliasReportTitle.FILETYPE;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // DOMINANT_LANGUAGE
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'DOMINANT_LANGUAGE';
        currentViewData.userFriendlyName = AliasReportTitle.DOMINANT_LANGUAGE;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // EMAIL_RECEIVER
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'EMAIL_RECEIVER';
        currentViewData.userFriendlyName = AliasReportTitle.EMAIL_RECEIVER;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // EMAIL_SENDER
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'EMAIL_SENDER';
        currentViewData.userFriendlyName = AliasReportTitle.EMAIL_SENDER;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // DATE_EMAIL_RECEIVED
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'DATE_EMAIL_RECEIVED';
        currentViewData.userFriendlyName = AliasReportTitle.DATE_EMAIL_RECEIVED;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // DATE_EMAIL_SENT
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'DATE_EMAIL_SENT';
        currentViewData.userFriendlyName = AliasReportTitle.DATE_EMAIL_SENT;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // LANGUAGE
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'LANGUAGE';
        currentViewData.userFriendlyName = AliasReportTitle.LANGUAGE;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // OCR_CANDIDATES
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'OCR_CANDIDATES';
        currentViewData.userFriendlyName = AliasReportTitle.OCR_CANDIDATES;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // OCR_CONFIDENCE_LEVEL
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'OCR_CONFIDENCE_LEVEL';
        currentViewData.userFriendlyName = AliasReportTitle.OCR_CONFIDENCE_LEVEL;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // OCR_SOURCE
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'OCR_SOURCE';
        currentViewData.userFriendlyName = AliasReportTitle.OCR_SOURCE;
        currentViewData.imports = false;
        currentViewData.dataSets = undefined;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // EMAIL_RECEIVED_DOMAINS
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'EMAIL_RECEIVED_DOMAINS';
        currentViewData.userFriendlyName = AliasReportTitle.EMAIL_RECEIVED_DOMAINS;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // IMPORT
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'IMPORT';
        currentViewData.userFriendlyName = AliasReportTitle.IMPORT;
        currentViewData.imports = undefined;
        currentViewData.dataSets = false;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // EMAIL_SENT_DOMAINS
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'EMAIL_SENT_DOMAINS';
        currentViewData.userFriendlyName = AliasReportTitle.EMAIL_SENT_DOMAINS;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // CORPUS_SOURCE
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'CORPUS_SOURCE';
        currentViewData.userFriendlyName = AliasReportTitle.CORPUS_SOURCE;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // TAG_SUMMARY
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'TAG_SUMMARY';
        currentViewData.userFriendlyName = AliasReportTitle.TAG_SUMMARY;
        currentViewData.imports = undefined;
        currentViewData.dataSets = undefined;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // IMPORT_ERROR
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'IMPORT_ERROR';
        currentViewData.userFriendlyName = AliasReportTitle.IMPORT_ERROR;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = undefined;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // REVIEW_FOLDER
        currentViewData = new ReportSettingViewData();
        currentViewData.reportId = 'REVIEW_FOLDER';
        currentViewData.userFriendlyName = AliasReportTitle.REVIEW_FOLDER;
        currentViewData.imports = false;
        currentViewData.dataSets = false;
        currentViewData.projectData = false;
        this.viewData.set(currentViewData.reportId, currentViewData);

        // POPULATION_SUMMARY - no longer used.
    }

    getViewData(reportId: string): ReportSettingViewData {
        let currentViewData = null;
        if (this.viewData) {
            currentViewData = this.viewData.get(reportId);
        }
        return currentViewData;
    }

    updateViewData(reportCategory: string, reportId: string, state: boolean): ReportSettingViewData {
        const currentViewData = this.getViewData(reportId);

        if (currentViewData) {
            switch (reportCategory) {
                case 'CORPUS_SET':
                    {
                        currentViewData.imports = state;
                    }
                    break;
                case 'CORPUS':
                    {
                        currentViewData.dataSets = state;
                    }
                    break;
                case 'WORKING_SET':
                    {
                        currentViewData.projectData = state;
                    }
                    break;
                default:
                    break;
            }

            // update the map with the new values
            this.viewData.set(reportId, currentViewData);
        }

        // return the data
        return currentViewData;
    }

    getViewDataAsSortedArray(): ReportSettingViewData[] {
        let reportArray = new Array<ReportSettingViewData>();
        let sortedArray: ReportSettingViewData[];
        if (this.viewData) {
            reportArray = Array.from(this.viewData.values());

            if (reportArray && (reportArray.length > 0)) {
                sortedArray = reportArray.sort((value1, value2) => {
                    if (value1.userFriendlyName > value2.userFriendlyName) {
                        return 1;
                    }

                    if (value1.userFriendlyName < value2.userFriendlyName) {
                        return -1;
                    }
                    return 0;
                });
            }
        }
        return sortedArray;
    }
}




